// extracted by mini-css-extract-plugin
export default {"searchButton":"_5395eaf1","rightDecorator":"_8388ecbe","label":"_4ade51cf"};